import { html } from "lit";

import { customElement } from "lit/decorators.js";

import "@phosphor-icons/webcomponents/PhBellSimple";

import { SignalElement, inject } from "ui-common/di";
import type { INotificationsState } from "ui-common/services/notifications/types";

import { notificationBellStyles } from "./notification-bell.css";

@customElement("notification-bell")
export class NotificationBell extends SignalElement {
  static override styles = notificationBellStyles;

  @inject<INotificationsState>("notificationsState")
  private notificationsState!: INotificationsState;

  private _handleClick() {
    this.dispatchEvent(new CustomEvent("click", { bubbles: true, composed: true }));
  }

  protected override render() {
    const unreadCount = this.notificationsState.unreadCount.get();

    return html`
      <div class="bell-container" @click=${this._handleClick}>
        <ph-bell-simple size="24"></ph-bell-simple>
        ${unreadCount > 0 ? html`<span class="badge">${unreadCount > 99 ? "99+" : unreadCount}</span>` : ""}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "notification-bell": NotificationBell;
  }
}
